module.exports = __webpack_public_path__ + "img/empty_announcement.e409952b.png";